/**
 * A titled group of setting rows. Groups stack vertically inside a section,
 * separated by the gap below rather than by a rule — SettingRow already draws
 * a divider between its own rows.
 */

.group {
  display: flex;
  flex-direction: column;
}

.group + .group {
  margin-top: 20px;
}

.title {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #6b7280;
  margin: 0 0 4px;
}
